import { stateSetters, stateGetters } from '@/store/store-utils'
import CasesGame from '@/store/models/games/cases/CasesGame'

const defaultState = {
  amount: 1,
  fast: false,
  sorting: 'price',
}

export default {
  name: 'games/cases',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
    list() {
      return CasesGame.all()
    },
  },
  mutations: {
    ...stateSetters(defaultState),
  },
  actions: {
    async get({ commit, getters }) {
      const cases = await this.$api.games.cases.list(getters.sorting)
      await CasesGame.insertOrUpdate({ data: cases })
    },
    async getBySlug({ commit }, slug) {
      const gameCase = await this.$api.games.cases.getBySlug(slug)
      if (!gameCase) return null

      await CasesGame.insertOrUpdate({ data: gameCase })

      return gameCase
    },
    async open({ commit, getters }, form) {
      const resp = await this.$api.games.cases.open({
        id: form.id,
        amount: getters.amount,
      })

      commit('user/addOrRemoveBalance', -form.price * getters.amount, { root: true })

      return resp
    },
  },
}
